import { URLS } from '../../constants';
import apiClient from '../client';

const getUserPermissions = {
  userPermission: (profileUserId: any = undefined, profileOrgId: any = undefined) =>
    apiClient.post(URLS.getUserPermission, {
      data: {
        profileUserId,
        profileOrgId,
      },
    }),
  userPermissionBychildId: (childId: any = undefined) =>
    apiClient.post(URLS.getUserPermissionByChildId, {
      data: {
        childId,
      },
    }),
};

export default getUserPermissions;
